/**
 * This component is responsible for listening to the titleService
 * and updating the website's actual title whenever the titleService's saved
 * title changes.
 */
export function titleUpdaterDirective() {
    return {
        controllerAs: 'titleCtrl',
        restrict: 'A',
        controller: function ($rootScope, $element, $scope, titleService) {
            'ngInject';
            let titleCtrl = this;

            /**
             * Sets the text in this directive's tags to the following.
             * @param text The text to set it to
             */
            titleCtrl.setContents = function (text) {
                $element.html(text);
            };

            const titleChangedListener = titleService.addOnTitleChangedListener((title) =>
                titleCtrl.setContents(title),
            );

            $scope.$on('$destroy', function () {
                titleChangedListener();
            });
        },
    };
}
